import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {kitsStoresTableReady,rowsPerPageState,searchTextState,paginationState} from '../redux/kits'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/productKits.css'

//import * as Helpers from '../../../common/helpers'
function filterUnwantedData(storeData) {
    let array = []
    if (storeData && storeData.data && storeData.data.List) {
        array = storeData.data.List
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let lineData = array[i]
           
            lineData.store_name=lineData.store.name
            lineData.kitchen_name=lineData.store.kitchen.name
            lineData.brand_name=lineData.store.brand.name
            newArray[i] = lineData
        }
    }
    return newArray
}


class KitsStoresTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            productRestaurantData: [],
            productSelected:{},
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(kitsStoresTableReady(false))


        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getStoreLocationData()

        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }


    
    getStoreLocationData = () => {



         if(this.props.kits && this.props.kits.productSelected && this.props.kits.productSelected !== null){
            this.props.dispatch(headerDataUpdate(Constants.KITS_STORES))
            this.props.dispatch(subHeaderDataUpdate(" - "+this.props.kits.productSelected.sku_name))

            let prevProductData= this.props.kits.productSelected                
                        this.setState({
                            productSelected:prevProductData
                        })

        apiService.getSellingStoresDetails(this.props.kits.productSelected.id)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.kits && this.props.kits.previousPaginationValue) {
                            pageNo = this.props.kits.previousPaginationValue
                        }
                        this.setState({
                            productRestaurantData: array,
                            page: pageNo,
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(kitsStoresTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(kitsStoresTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })

        }
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.kits && this.props.kits.previousRowsPerPageValue) {
            value = this.props.kits.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

   

    createCustomToolBar = props => {
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   
                   <div className="col-xs-12 col-sm-12 col-md-10 header-div-margins">
                            <a href="" 
                                onClick={(e) => {e.preventDefault() 
                                            this.props.history.goBack()}}> 
                                    <i class="fa fa-arrow-left" aria-hidden="true"></i> Go Back
                            </a>
                    </div>

                   <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()
                                this.updateLocation()
                            }}>
                            Add/Edit Stores
                        </button>
                    </div>

                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.productRestaurantData.length>=(this.props.kits.previousPaginationValue*this.props.kits.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.kits.previousPaginationValue*this.props.kits.previousRowsPerPageValue)-this.props.kits.previousRowsPerPageValue+1} to {this.props.kits.previousPaginationValue*this.props.kits.previousRowsPerPageValue} of {this.state.productRestaurantData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.kits.previousPaginationValue*this.props.kits.previousRowsPerPageValue)-this.props.kits.previousRowsPerPageValue+1} to {this.state.productRestaurantData.length} of {this.state.productRestaurantData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredBrandList = () => {
       
        this.props.dispatch(kitsStoresTableReady(false))
        this.resetSearchAndPagination()
        this.getStoreLocationData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getStoreLocationData()
        this.props.dispatch(kitsStoresTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

    updateLocation = () => {
        if (this.state.productSelected) {
            this.props.history.push("/dashboard/kits/stores/updatelocation")
        } else {
            this.dialog.show({
                title: "Product Id not found",
                body: 'Product id is not available, So not able update location',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }  
    }

    actionButtonsCreator = (cell, row) => {
        let editButton =
        
            <button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editBrand(row)
                }}>
                Edit
            </button>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.kits && this.props.kits.previousPaginationState
            && this.props.kits.previousPaginationState !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editBrand = (row) => {
        // if (row && row.id) {
        //     this.props.dispatch(brandIdForAction(row.id))
        //     this.props.history.push("/dashboard/brand/addedit")
        // } else {
        //     this.dialog.show({
        //         title: "Brand Identification number not found",
        //         body: 'Brand id is not available, So not able edit brand',
        //         actions: [
        //             Dialog.OKAction(() => {
        //             })
        //         ],
        //     })
        // }
    }

    render() {
        let sizeperPage = 15

        if (this.props.kits && this.props.kits.previousRowsPerPageValue) {
            sizeperPage = this.props.kits.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (


            <div className="product-location-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                        
                <Dialog ref={el => this.dialog = el} />
                    <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.productRestaurantData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight }}
                   >
                    <TableHeaderColumn
                        dataField="id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Id
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="store_name"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Restaurant Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="kitchen_name"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Kitchen Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="brand_name"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Brand Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="quantity"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Quantity
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="estimated_cost"
                        dataSort={true}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Estimated Cost
                    </TableHeaderColumn>

                    
                     <TableHeaderColumn
                        dataSort={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Action
                    </TableHeaderColumn>
                </BootstrapTable>

            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        kits: state.kits
    }
}

export default connect(mapStateToProps)(withRouter(KitsStoresTable))


// WEBPACK FOOTER //
// ./src/modules/Kits/Components/KitsStoresTable.js